// src/modules/Courier/pages/CourierModal/pages/Scanners/ScannerTSD.jsx
import React, { useRef, useEffect } from "react";
import { useRouteStore } from "../../../Route/useRouteStore";
import styles from "./styles/ScannerTSD.module.css";

/**
 * TSD-сканер: фокусирует input и отправляет нажатия Enter как скан.
 */
export default function TSDComponent({ onMarkScanned }) {
  const inputRef = useRef(null);
  const { addLog, setStatusMessage } = useRouteStore();

  // Фокус при монтировании
  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  // Всегда возвращаем фокус на input при нажатии клавиш
  useEffect(() => {
    const keepFocus = () => {
      if (inputRef.current && document.activeElement !== inputRef.current) {
        inputRef.current.focus();
      }
    };
    document.addEventListener("keydown", keepFocus);
    return () => document.removeEventListener("keydown", keepFocus);
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      const code = inputRef.current.value.trim();
      if (!code) return;
      addLog(`ТСД скан: ${code}`);
      try {
        onMarkScanned(code);
      } catch {
        setStatusMessage("Ошибка при сканировании");
      }
      inputRef.current.value = "";
    }
  };

  const handleFocus = () => {
    setTimeout(() => {
      inputRef.current?.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
    }, 0);
  };

  return (
    <div className={styles.container}>
      <input
        type="tel"
        inputMode="none"
        autoCorrect="off"
        autoComplete="off"
        ref={inputRef}
        onKeyDown={handleKeyDown}
        onFocus={handleFocus}
        onTouchStart={(e) => e.preventDefault()}
        placeholder="Сканируйте код..."
        className={styles.input}
      />
    </div>
  );
}
